firebird.controller('meetingEndedThankYouCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'attendeeService',
    'cfpLoadingBar',
    'helperService',
    'meetingService',
    'brandingService',
    'uniteNotificationService',
    'camaroService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        attendeeService,
        cfpLoadingBar,
        helperService,
        meetingService,
        brandingService,
        uniteNotificationService,
        camaroService
    ) {
        const self = this;

        self.init = init;
        self.initiateEndMeetingFlow = initiateEndMeetingFlow;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.showRedirectMessage = showRedirectMessage;

        $scope.$on('callstat-survey-completed', onCallstatSurveyCompleted);
        $scope.$on('survey-completed', onSurveyCompleted);

        init();

        ////////////////////////

        function init() {
            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            // if (
            //     attendeeService.shouldUseCallstatSurvey() &&
            //     !attendeeService.getCompletedCallstatSurvey() &&
            //     attendeeService.getIsHost() == false
            // ) {
            //     $timeout(function () {
            //         $scope.$broadcast('show-modal', 'callstatsQualityFeedback', self.initiateEndMeetingFlow);
            //     }, 1000);
            // } else {
            //     self.initiateEndMeetingFlow();
            // }
            self.initiateEndMeetingFlow();

            // Exit compact mode if meeting ends while in compact mode layout
            $rootScope.$broadcast('enable-compact-mode', false);
        }

        function onCallstatSurveyCompleted(e, data) {
            if (helperService.isUniteApplication()) {
                camaroService.closeWindowForced();
            } else if (data && !data.hostIssuedRedirect) {
                self.initiateEndMeetingFlow();
            }
        }

        function onSurveyCompleted() {
            if (helperService.isUniteWeb()) {
                uniteNotificationService.sendMeetingEndedEvent();
            } else if (helperService.isUniteApplication()) {
                camaroService.closeWindow();
            } else if (helperService.isStartedFromWebinarDashboard()) {
                $window.location.href = helperService.getWebinarDashboardRedirectUrl();
            } else if (isAccountManagerAvailable()) {
                $window.location.href = helperService.getAccountManagerRedirectUrl();
            } else {
                // do not show loader if no redirects
                cfpLoadingBar.complete();
            }
        }

        function initiateEndMeetingFlow() {
            if (attendeeService.getIsHost() === true) {
                cfpLoadingBar.start();
            } else if (!helperService.isMobile() && brandingService.isAnymeetingDirect()) {
                $timeout(function () {
                    if (helperService.isElectron()) {
                        $window.location.href = `${helperService.getLocationProtocol()}://www.${helperService.getLocationHost()}/AccountManager/`;
                    } else {
                        $window.location.href = `${helperService.getLocationProtocol()}://www.${helperService.getLocationHost()}/EndMeetingSignup.aspx`;
                    }
                }, 5000);
            }
        }

        function showRedirectMessage() {
            return attendeeService.getIsHost() && isAccountManagerAvailable();
        }

        function isAccountManagerAvailable() {
            return !helperService.isUniteApplication() && brandingService.isAccountManagerAvailable();
        }
    }
]);
